module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-banner-3@2x-8b0845de5aa5819fc59a0299cd5ee76b.png";